import { render, staticRenderFns } from "./DoctorForeverRewardDetails.vue?vue&type=template&id=43879245&scoped=true"
import script from "./DoctorForeverRewardDetails.vue?vue&type=script&lang=js"
export * from "./DoctorForeverRewardDetails.vue?vue&type=script&lang=js"
import style0 from "./DoctorForeverRewardDetails.vue?vue&type=style&index=0&id=43879245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43879245",
  null
  
)

export default component.exports